import { getHistoryData } from "../../data/ramotswe";
import {
  changeBinnedTimeSeriesUTCTimeToLocalTime,
  createNullBinnedTimeSeriesData,
  getCurrentObservatoryName,
  getBinnedXValues,
  getXLims,
  ensureYKeyPresence,
  trimNullEdges,
} from "../../utils";
import { DashboardTimeLineGraph } from "../../graphs/base_graphs";
import { DateTime } from "../../imports";

export default async function initializeTemperatureHumidity() {
  // define how the data is fetched
  async function getData() {
    const endDateTime = DateTime.now().setZone("UTC");
    const startDateTime = endDateTime.minus({ days: 1 });

    let data = await getHistoryData(
      getCurrentObservatoryName(),
      "binnedtelemetrydata",
      startDateTime,
      endDateTime,
      { model: "Cumulus", column_names: ["temperature", "humidity"] }
    );
    if (data === null || data.length === 0) {
      data = createNullBinnedTimeSeriesData(
        "temperature",
        startDateTime,
        endDateTime
      );
      data.forEach((element) => (element.humidity = null));
    }

    // process data
    data = changeBinnedTimeSeriesUTCTimeToLocalTime(data);
    data = ensureYKeyPresence(data, ["temperature", "humidity"]);
    data = trimNullEdges(data, ["temperature", "humidity"]);

    return [data, getXLims(getBinnedXValues(data))];
  }

  // set up the initial data and axes
  const [initialData, xLims] = await getData();

  const temperatureHumidityGraph = new DashboardTimeLineGraph(
    "#temp-humidity-graph",
    "Time",
    "Temperature [°C]",
    "Relative Humidity [%]"
  );

  // set the graph parameters for consistency in initialization & refresh
  function makeBarGraphParams(allGraphData, hideSVG, xLims) {
    return [
      allGraphData, // all data is in one array
      "time_bin_edges",
      "humidity",
      {
        secondAxis: true,
        transition: true,
        staticYlims: [0, 100],
        hideSVG: hideSVG,
        staticXlims: xLims,
      },
    ];
  }
  function makeLineGraphParams(allGraphData, hideSVG, xLims) {
    return [
      allGraphData,
      "time_bin_center",
      "temperature",
      {
        secondAxis: false,
        transition: true,
        staticYlims: [-20, 45],
        hideSVG: hideSVG,
        staticXlims: xLims,
      },
    ];
  }

  // populate the graphs, saving the names of them
  const barAxesKey = temperatureHumidityGraph.makeBarGraph(
    ...makeBarGraphParams(initialData, true, xLims)
  );
  const lineAxesKey = temperatureHumidityGraph.makeLineGraph(
    ...makeLineGraphParams(initialData, true, xLims)
  );
  temperatureHumidityGraph.showLoading();

  // define the refresh function
  async function refresh() {
    temperatureHumidityGraph.showLoading();
    const [newData, xLims] = await getData();

    // updateData has the same format as make*Graph, but with the key as param 1
    temperatureHumidityGraph.updateData(
      lineAxesKey,
      ...makeLineGraphParams(newData, false, xLims)
    );
    temperatureHumidityGraph.updateData(
      barAxesKey,
      ...makeBarGraphParams(newData, false, xLims)
    );
  }

  return refresh;
}
